<template>
    <div class="message-sent-2-step">
        <b-img
                :src="require('../../../../static/get-connected/get-connected-sent-image.png')"
                width="100px"
        />
        <h1 class="message-sent-2-step-title">
            Message Sent!
        </h1>
        <p class="message-sent-2-step-sub-title">
            You'll receive a reply from your selections soon.
        </p>
        <b-button
                size="lg"
                variant="primary"
                @click="handleClose"
                class="message-sent-2-step-close"
        >
            Close
        </b-button>
    </div>
</template>

<script>
import './MessageSent2Step.scss';

export default {
    name: "MessageSent2Step",
    methods: {
        handleClose() {
            this.$emit('close');
        }
    }
}
</script>